import { type Framework } from '@toeverything/infra';

import { WorkspaceServerService } from '../cloud';
import { GlobalCache } from '../storage';
import { WorkspaceScope, WorkspaceService } from '../workspace';
import { NavigationPanelService } from './services/navigation-panel';
import { NavigationPanelRevealService } from './services/reveal';
export { NavigationPanelService } from './services/navigation-panel';
export {
  NavigationPanelRevealService,
  shouldNavigationPanelRevealOpenSidebar,
} from './services/reveal';

export function configureNavigationPanelModule(framework: Framework) {
  framework.service(NavigationPanelRevealService);
  framework
    .scope(WorkspaceScope)
    .service(NavigationPanelService, [
      GlobalCache,
      WorkspaceService,
      WorkspaceServerService,
    ]);
}
